import {logger as SentryLogger} from '@sentry/react';

export type SelectedSubscriptionState = {
    selectedSubsId: string | null;
    permanentVehicleId: string | null;
    selectedPlan: string | null;
    noticeGiven: string | null;
    onboardVersion: string | null;
};

export type SelectedSubscriptionAction =
    | {
        type: "SELECT_SUBSCRIPTION";
        payload: {
            subsId: string;
            vehicleId: string;
            selectedPlan: string;
            noticeGiven?: string;
            onboardVersion?: string;
        };
    }
    | { type: "SET_NOTICE_GIVEN"; payload: string | null };

export const selectedSubscriptionInitialState: SelectedSubscriptionState = {
    selectedSubsId: null,
    permanentVehicleId: null,
    selectedPlan: null,
    noticeGiven: null,
    onboardVersion: null
};

export function selectedSubscriptionReducer(state: SelectedSubscriptionState, action: SelectedSubscriptionAction): SelectedSubscriptionState {
    switch (action.type) {
        case "SELECT_SUBSCRIPTION":
            SentryLogger.debug("Selected subscription for cancellation: " + JSON.stringify(action.payload));
            return {
                ...state,
                selectedSubsId: action.payload.subsId,
                permanentVehicleId: action.payload.vehicleId,
                selectedPlan: action.payload.selectedPlan,
                noticeGiven: action.payload.noticeGiven || null,
                onboardVersion: action.payload.onboardVersion || null
            };
        case "SET_NOTICE_GIVEN":
            return { ...state, noticeGiven: action.payload };
        default:
            console.log(`Error - incorrect action sent ${action} ${state}`)
            return state;
    }
}